import { GridFooterCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { FC } from 'react';
import useViewAccrual from 'src/hooks/useViewAccrual';

export const CountFooterCell: FC<GridFooterCellProps> = (props) => {
  const { field = '' } = props;
  const { totals } = useViewAccrual();
  const intl = useInternationalization();

  return <td>{intl.format('{0:2}', (totals as any)?.[field])}</td>;
};
